import React, { useCallback } from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import { SortIcon } from "@td/ui";
import classNames from "classnames";
import { sortOrderTypes } from "../../constants";

const ListViewSortButton = React.memo(({ name, value, onClick, children }) => {
  const { column, order } = value;

  const handleClick = useCallback(() => {
    if (column !== name) {
      onClick({
        column: name,
        order: sortOrderTypes.ASC,
      });
    } else {
      onClick({
        column: name,
        order: (order === sortOrderTypes.ASC)
          ? sortOrderTypes.DESC
          : sortOrderTypes.ASC,
      });
    }
  }, [onClick, name, column, order]);

  return (
    <button
      onClick={handleClick}
      className={styles.listViewSortButton}
      data-testid="list-view-sort-button"
    >
      {children}

      {column === name && (
        <div
          className={classNames(styles.listViewSortButtonIcon, {
            [styles.listViewSortButtonIconDesc]: order === sortOrderTypes.DESC,
          })}
        >
          <SortIcon
            width={8}
            height={13}
            fill="#000000"
          />
        </div>
      )}
    </button>
  );
});

ListViewSortButton.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.shape({
    column: PropTypes.string.isRequired,
    order: PropTypes.string.isRequired,
  }),
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default ListViewSortButton;
